import * as modalTypes from 'constants/modal_types'

export const selectIsLabelingModalOpen = state =>
  state.modal.modalType === modalTypes.LABELING_EDIT
